import React, { FC } from 'react'
import Img, { StaticImageData } from 'next/image'
import { imgix } from '@lojinha/helpers'

import { Box, Stack, Text, useWindowProperties } from '@lojinha/design-system'

interface MGMStepProps {
  image: string | StaticImageData
  title: string
  description: string
  ariaLabel?: string
}

export const MGMStep: FC<MGMStepProps> = ({
  image,
  title,
  description,
  ariaLabel,
}) => {
  const { isMobile } = useWindowProperties()

  return isMobile ? (
    <Box py={'x12'}>
      <Stack layout={'horizontal'}>
        <Box minWidth={75} width={75} display={'flex'} alignItems={'center'}>
          <Img
            loader={({ src }) => imgix.withParams(src)}
            src={image}
            alt={title}
            width={75}
            height={75}
          />
        </Box>
        <Stack margin={'x0'}>
          <Text isBold color={'grapeLightSupport'}>
            {title}
          </Text>
          <Text
            htmlAttrs={{ 'aria-label': ariaLabel }}
            textSize={'x2'}
            color={'grapeLightSupport'}
          >
            {description}
          </Text>
        </Stack>
      </Stack>
    </Box>
  ) : (
    <div>
      <Box minWidth={118} width={118} display={'flex'} alignItems={'center'}>
        <Img
          loader={({ src }) => imgix.withParams(src)}
          src={image}
          alt={title}
          width={128}
          height={112}
        />
      </Box>
      <Text isBold color={'grapeLightSupport'}>
        {title}
      </Text>
      <Text
        htmlAttrs={{ 'aria-label': ariaLabel }}
        textSize={'x2'}
        color={'grapeLightSupport'}
      >
        {description}
      </Text>
    </div>
  )
}
